module.exports = __webpack_public_path__ + "static/media/lion.4872ef12.jpg";